import React, { useState } from "react";
import { DatePicker, Table } from "antd";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import { format } from "date-fns";
import dayjs from "dayjs";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import Select from "react-select";
import ReportTools from "Components/UI/ReportTools";
import MonthOption from "Components/Form/MonthSelect";
import YearOption from "Components/Form/YearSelect";
import { usePayrollSummaryQuery } from "AppQuries/report/get-payroll-summary";
import { BackIcon } from "Components/UI/Icon/Icons";
const MonthlyPayrollSummary = () => {
  const userData = useSelector(loggedInUser);

  const [filter, setFilter] = useState({
    month: format(new Date(), "MM"),
    year: format(new Date(), "yyyy"),
    companyCode: userData.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const monthSelectHandler = (e) => {
    console.log(e);
    setFilter((prev) => {
      return {
        ...prev,
        month: e,
      };
    });
  };

  const yearSelectHandler = (e) => {
    setFilter((prev) => {
      return {
        ...prev,
        year: e,
      };
    });
  };
  const [employeeCode, setEmployeeCode] = useState(0);

  const {
    data,
    isFetching,
    isError,
    error,
    refetch: getReport,
  } = usePayrollSummaryQuery(
    {
      ...filter,
      employeeCode: employeeCode,
      userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
    },
    {
      enabled: !!filter.month && !!filter.year && !!filter.companyCode,
    },
  );

  const reportData = data?.map((d, _id) => ({
    ...d,
    id: _id + 1,
  }));

  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const employeeOptions =
    employees
      ?.filter((d) => d.isActive)
      .map((o) => ({
        id: o.employeeCode,
        label: `${o.uniqueId}-${o.fullName}`,
        value: o.employeeCode,
      })) || [];
  const [isFilterVisible, setIsFilterVisible] = useState(true);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID - b.uniqueID,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
    },
    {
      title: "Month",
      dataIndex: "month",
      sorter: (a, b) => a.month.length - b.month.length,
    },
    {
      title: "Year",
      dataIndex: "processYear",
      sorter: (a, b) => a.processYear.length - b.processYear.length,
    },
    {
      title: "Basic Salary",
      dataIndex: "basicSalary",
      sorter: (a, b) => a.basicSalary.length - b.basicSalary.length,
      render: (text, record) => Number(text).toFixed(2),
    },
    {
      title: "Addition",
      dataIndex: "addition",
      sorter: (a, b) => a.addition.length - b.addition.length,
      render: (text, record) => Number(text).toFixed(2),
    },
    {
      title: "Deduction",
      dataIndex: "deduction",
      sorter: (a, b) => a.deduction.length - b.deduction.length,
      render: (text, record) => Number(text).toFixed(2),
    },
    {
      title: "Employee CPF",
      dataIndex: "employeeCPF",
      sorter: (a, b) => a.employeeCPF.length - b.employeeCPF.length,
      render: (text, record) => Number(text).toFixed(2),
    },
    {
      title: "Employer CPF",
      dataIndex: "employerCPF",
      sorter: (a, b) => a.employerCPF.length - b.employerCPF.length,
      render: (text, record) => Number(text).toFixed(2),
    },
    {
      title: "Net Pay",
      dataIndex: "netPay",
      sorter: (a, b) => a.netPay.length - b.netPay.length,
      render: (text, record) => Number(text).toFixed(2),
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    reportData,
    searchColumns,
  );
  if (isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Payroll Summary Report</h4>
              <h6>Monthly Payroll Summary Report</h6>
            </div>
          </div>
          <ReportTools
            columns={columns}
            data={reportData}
            fileName={`Monthly Report ${filter.month} - ${filter.year}`}
            pdfTheme="striped"
            refresh={getReport}
          />
          <div className="page-btn">
            <Link
              to={`${all_routes.report_list}`}
              f
              className="btn btn-secondary"
            >
              <BackIcon className="me-2" />
              Back
            </Link>
          </div>
        </div>

        <div className="card table-list-card border-0">
          <div className="card-body">
            <TableTop
              onSearch={setSearchValue}
              toggleFilterVisibility={toggleFilterVisibility}
              isFilterVisible={isFilterVisible}
              showToggle={true}
            />
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              // style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                <div className="form-row row">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Employee </label>

                        <Select
                          className="select"
                          options={employeeOptions}
                          placeholder="Employee"
                          value={employeeOptions.find(
                            (option) => option.value === employeeCode,
                          )}
                          onChange={(e) => {
                            setEmployeeCode(e?.value || 0);
                          }}
                          isClearable
                          //   styles={{
                          //     control: (baseStyles, state) => ({
                          //       ...baseStyles,
                          //       fontSize: "12px",
                          //       width: "100px",
                          //     }),
                          //   }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Month</label>
                        <MonthOption
                          selectedMonth={filter.month}
                          monthSelectHandler={monthSelectHandler}
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 mb-3">
                      <div className="form-group">
                        <label className="form-label">Year</label>
                        <YearOption
                          selectedYear={filter.year}
                          yearSelectHandler={yearSelectHandler}
                        />
                      </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-12">
                      <div className="input-blocks">
                        <label className="form-label">&nbsp;</label>
                        <Link
                          className="btn btn-filters ms-auto"
                          onClick={getReport}
                          type="button"
                        >
                          <i data-feather="search" className="feather-search" />
                          {isFetching ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-2"></i>
                              Loading...
                            </>
                          ) : (
                            <>Filter</>
                          )}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table
                className="table  datanew"
                columns={columns}
                dataSource={filteredData}
                summary={() => {
                  if (!filteredData || filteredData.length === 0) return null;

                  const totalSalary = filteredData?.reduce(
                    (sum, r) => sum + (r.basicSalary || 0),
                    0,
                  );

                  const totalAddition = filteredData?.reduce(
                    (sum, r) => sum + (r.addition || 0),
                    0,
                  );

                  const totalDeduction = filteredData?.reduce(
                    (sum, r) => sum + (r.deduction || 0),
                    0,
                  );

                  const totalEmployeeCpf = filteredData?.reduce(
                    (sum, r) => sum + (r.employeeCpf || 0),
                    0,
                  );

                  const totalEmployerCpf = filteredData?.reduce(
                    (sum, r) => sum + (r.employerCpf || 0),
                    0,
                  );

                  const totalCpf = filteredData?.reduce(
                    (sum, r) => sum + (r.totalCpf || 0),
                    0,
                  );

                  const totalNetPay = filteredData?.reduce(
                    (sum, r) => sum + (r.netPay || 0),
                    0,
                  );

                  return (
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0} colSpan={4}>
                        <div className="text-center">
                          <b>Total</b>
                        </div>
                      </Table.Summary.Cell>

                      <Table.Summary.Cell index={5}>
                        <b>{totalSalary}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={6}>
                        <b>{totalAddition}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={7}>
                        <b>{totalDeduction}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={8}>
                        <b>{totalEmployeeCpf}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={9}>
                        <b>{totalEmployerCpf}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={10}>
                        <b>{totalCpf}</b>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={11}>
                        <b>{totalNetPay}</b>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyPayrollSummary;
